import { useQuery } from "@tanstack/react-query";
import { apiClient, buildQueryParams } from "@finitless/shared/lib";

/**
 * Build where clause for drivers (level 4)
 */
const buildDriverWhereClause = (searchTerm = "") => {
  const baseWhere = {
    conditions: [
      {
        attribute: "level",
        value: [4], // Drivers level
      },
    ],
    conector: "AND",
  };

  // Add search condition
  if (searchTerm && searchTerm.trim()) {
    const searchValue = `%${searchTerm.trim()}%`;
    baseWhere.conditions.push({
      conector: "OR",
      conditions: [
        {
          attribute: "name",
          value: {
            condition: "ilike",
            value: searchValue,
          },
        },
        {
          attribute: "lastname",
          value: {
            condition: "ilike",
            value: searchValue,
          },
        },
        {
          attribute: "email",
          value: {
            condition: "ilike",
            value: searchValue,
          },
        },
        {
          attribute: "cellphone",
          value: {
            condition: "ilike",
            value: searchValue,
          },
        },
      ],
    });
  }

  return baseWhere;
};

/**
 * Hook to get drivers (level 4) with optional search
 */
export const useDrivers = (searchTerm = "") => {
  const whereClause = buildDriverWhereClause(searchTerm);

  const params = {
    params: "id,name,lastname,email,cellphone,country_phone_code,photo,enabled",
    where: whereClause,
    page: 1,
    page_size: 1000, // Get all drivers for selection
    orderBy: "-id",
  };

  const queryString = buildQueryParams(params);

  return useQuery({
    queryKey: ["drivers", searchTerm],
    queryFn: async () => {
      const response = await apiClient.get(
        `/users${queryString ? `?${queryString}` : ""}`,
      );
      return {
        drivers: response?.result || [],
        pagination: response?.pagination || {},
      };
    },
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false,
  });
};
